import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { usePoll } from "@/hooks/usePoll";

const TachoCtx = createContext(null);

export function TachoProvider({ children }) {
  const [base, setBase] = useState(null);
  const [tick, setTick] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/tacho");
      setBase({ ...data, fetchedAt: Date.now() });
    } catch {
      /* ignore */
    }
  }, []);

  usePoll(refresh, 30000);

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => {
      clearInterval(id);
    };
  }, []);

  let tacho = null;
  if (base) {
    const el = (Date.now() - base.fetchedAt) / 1000;
    const drive = base.is_driving ? el : 0;
    const contRem = Math.max(0, base.continuous_remaining_sec - drive);
    const dayRem = Math.max(0, base.daily_remaining_sec - drive);
    const rem = Math.min(contRem, dayRem);
    const brk = base.on_break ? base.break_elapsed_sec + el : 0;
    const level = rem <= 0 ? "exceeded" : rem <= 900 ? "critical" : rem <= 2700 ? "warning" : "ok";
    tacho = {
      ...base,
      continuous_remaining_sec: contRem,
      daily_remaining_sec: dayRem,
      remaining_sec: rem,
      level,
      break_elapsed_sec: brk,
      break_remaining_sec: Math.max(0, base.break_required_sec - brk),
      _tick: tick,
    };
  }

  return <TachoCtx.Provider value={{ tacho, refresh }}>{children}</TachoCtx.Provider>;
}

export const useTacho = () => useContext(TachoCtx);
